import * as React from 'react';
import { useTranslator } from '@gandi/translate';
import { Alert } from '@gandi/ui';
import { useFeatureFlag } from '../../../hooks/useFeatureFlag';
import { OrderStatusHeader } from './OrderStatusHeader';
import { jsx as _jsx } from "react/jsx-runtime";
export default function OrderError() {
  const {
    __
  } = useTranslator();
  const FFShopConfirmationNDS = useFeatureFlag('FF_SHOP_CONFIRMATION_NDS');
  if (FFShopConfirmationNDS) {
    return /*#__PURE__*/_jsx(OrderStatusHeader, {
      title: __('Oops, something went wrong!'),
      icon: "error",
      content: __('We’re sorry for the inconvenience. Don’t worry, no payment has been made.')
    });
  }
  return /*#__PURE__*/_jsx(Alert, {
    message: __('Unable to retrieve your order.'),
    intent: "danger"
  });
}